
export const TRANSFORMERS_URL = 'https://transformers.pubfront.com';

export const TRACK_ASSET_TYPE = Object.freeze({
  primary: 1,
  secondary: 2,
});
